import { formatPreAdmissionDate } from '@/helpers/dates';
import {
  sendPreAdmissionData,
  optionPreAdmission
} from '@/services/preAdmission';

function formatPhoneNumber(phoneNumber) {
  if (phoneNumber.startsWith("+41/")) {
    return phoneNumber.length === 14 ? phoneNumber.slice(0, 3) + "/" + phoneNumber.slice(5) : phoneNumber;
  } else {
    return phoneNumber;
  }
}

export const state = {
  preAdmissionData: {
    date: null,
    patient: {
      first_name: null,
      last_name: null,
      birthdate: null,
      birth_name: null,
      avs_no: null,
      insurance_card_no: null,
      nationality: null,
      insurances: [
        {
          name: null
        }
      ],
      job: null,
      emails: [],
      phones: [],
      addresses: []
    },
    physicians: [],
    appointment: {
      datetime: null,
      motive: null,
      accident: null,
      site: 'fribourg'
    },
    emergency_contacts: [],
    administrative_contacts: []
  },
  preAdmissionOptions: {},
  civilStates: null,
  sites: null,
  administrativeContactsRelationships: null,
  emergencyContactsRelationships: null,
  confessions: null,
  preAdmissionSuccess: false,
  roomDivisions: null,
  userInfo: null,
  languages: null,
  genders: null,
  rdvStepReasons: null,
};

export const mutations = {
  storePreAdmissionData(state, data) {
    state.preAdmissionData = data;
  },
  storePreAdmissionOptions(state, data) {
    state.preAdmissionOptions = data;
  },
  storeCivilStates(state, data) {
    state.civilStates = data;
  },
  storeSites(state, data) {
    state.sites = data;
  },
  storeRoomDivisions(state, data) {
    state.roomDivisions = data;
  },
  storeConfessions(state, data) {
    state.confessions = data;
  },
  storeAdministrativeContactsRelationships(state, data) {
    state.administrativeContactsRelationships = data;
  },
  storeEmergencyContactsRelationships(state, data) {
    state.emergencyContactsRelationships = data
  },
  storeFcmRegistrationToken(state, token) {
    state.preAdmissionData.fcm_registration_token = token;
  },
  storeUserInfo(state, data) {
    state.userInfo = data
  },
  storeLanguages(state, data) {
    state.languages = data
  },
  storeGenders(state, data) {
    state.genders = data
  },
  storeRdvStepReasons(state, data) {
    state.rdvStepReasons = data
  },
  storeIdentifierStep(state, data) {
    state.preAdmissionData.patient.insurance_card_no = data.insuranceCardNumber;
    state.preAdmissionData.patient.insurances = [];
    state.preAdmissionData.patient.insurances.push({
      name: data.insuranceName
    });
    state.preAdmissionData.patient.first_name = data.firstName;
    state.preAdmissionData.patient.last_name = data.lastName;
    state.preAdmissionData.patient.birthdate = data.birthdate;
    state.preAdmissionData.patient.avs_no = data.avs_no;
  },
  storeRdvStep(state, data) {
    state.preAdmissionData.appointment.datetime =
      data.rdvDate + ' ' + data.rdvHour;
    state.preAdmissionData.appointment.motive = data.reason;
    state.preAdmissionData.appointment.accident = data.accident;
    state.preAdmissionData.appointment.site = data.site;
  },
  storePersonalDataStep(state, data) {
    state.preAdmissionData.patient.birth_name = data.birthFamilyName;
    state.preAdmissionData.patient.sex = data.gender;
    state.preAdmissionData.patient.nationality = data.nationality;
    state.preAdmissionData.patient.contact_language = data.language;
    state.preAdmissionData.patient.civil_state = data.maritalStatus;
    state.preAdmissionData.patient.confession = data.confession;
    state.preAdmissionData.patient.addresses = [];
    state.preAdmissionData.patient.addresses.push({
      street: data.street,
      zip_code: data.zip,
      city: data.city
    });
    state.preAdmissionData.patient.emails = [];
    state.preAdmissionData.patient.emails.push({
      address: data.mail
    });
    state.preAdmissionData.patient.phones = [];
    state.preAdmissionData.patient.phones.push({ number: formatPhoneNumber(data.mobilePhone) });
    if (data.fixPhone && data.fixPhone.split('/')[1]) {
      state.preAdmissionData.patient.phones.push({ number: formatPhoneNumber(data.fixPhone) });
    }
    state.preAdmissionData.date = formatPreAdmissionDate(new Date());
  },
  storeEmployerStep(state, data) {
    if (data.noEmployer === true) {
      delete state.preAdmissionData.patient.job;
    } else {
      state.preAdmissionData.patient.job = {
        name: data.name,
        employer_name: data.employerName,
        employer_zip_code: data.employerZip,
        employer_city: data.employerCity
      };
    }
  },
  storeContactsStep(state, data) {
    state.preAdmissionData.administrative_contacts = [];
    data.administrativeContacts.forEach((contact) => {
      state.preAdmissionData.administrative_contacts.push({
        first_name: contact.firstName,
        last_name: contact.lastName,
        relationship: contact.relationship,
        addresses: [
          {
            street: contact.street,
            zip_code: contact.zip,
            city: contact.city
          }
        ],
        emails: [
          {
            address: contact.email
          }
        ]
      });
    });

    state.preAdmissionData.emergency_contacts = [];
    data.emergencyContacts.forEach((contact) => {
      state.preAdmissionData.emergency_contacts.push({
        relationship: contact.relationship,
        first_name: contact.firstName,
        last_name: contact.lastName,
        addresses: [],
        phones: [
          ...(contact.phone && contact.phone.split('/')[1]) && [{
            number: formatPhoneNumber(contact.phone)
          }]
        ]
      });
    });
  },
  storeDoctorStep(state, data) {
    state.preAdmissionData.physicians = [];
    if (data.noFamilyDoctor !== true) {
      let familyDoctor = {
        addresses: [
          {
            zip_code: data.familyDoctor.zip,
            city: data.familyDoctor.city
          }
        ],
        phones: [],
        first_name: data.familyDoctor.firstName,
        last_name: data.familyDoctor.lastName,
        type: 'F'
      };
      if (
        data.familyDoctor.street !== null &&
        data.familyDoctor.street !== ''
      ) {
        familyDoctor.addresses[0].street = data.familyDoctor.street;
      }
      if (data.familyDoctor.phone !== null && data.familyDoctor.phone !== '' && data.familyDoctor.phone.split('/')[1]) {
        familyDoctor.phones.push({
          number: formatPhoneNumber(data.familyDoctor.phone)
        });
      }
      state.preAdmissionData.physicians.push(familyDoctor);
    }
    if (data.noSenderDoctor !== true) {
      let senderDoctor = {
        addresses: [
          {
            zip_code: data.senderDoctor.zip,
            city: data.senderDoctor.city
          }
        ],
        phones: [],
        first_name: data.senderDoctor.firstName,
        last_name: data.senderDoctor.lastName,
        type: 'S'
      };
      if (
        data.senderDoctor.street !== null &&
        data.senderDoctor.street !== ''
      ) {
        senderDoctor.addresses[0].street = data.senderDoctor.street;
      }
      if (data.senderDoctor.phone !== null && data.senderDoctor.phone !== '' && data.senderDoctor.phone.split('/')[1]) {
        senderDoctor.phones.push({
          number: formatPhoneNumber(data.senderDoctor.phone)
        });
      }
      state.preAdmissionData.physicians.push(senderDoctor);
    }
  },
  storeAssurancesStep(state, data) {
    state.preAdmissionData.patient.avs_no = data.avs_no;
    state.preAdmissionData.patient.insurances = [];
    state.preAdmissionData.patient.insurances.push({
      name: data.name,
      type: 'B'
    });
    if (data.additionalInsurance !== null)
      state.preAdmissionData.patient.insurances.push({
        name: data.additionalInsurance.name,
        type: 'C',
        complementary_card_no: data.additionalInsurance.insuranceCardNumber,
        room_division: data.additionalInsurance.roomDivision,
      });
    if (data.accidentInsurance !== null)
        state.preAdmissionData.patient.insurances.push({
        name: data.accidentInsurance.name,
        accidentDate: data.accidentInsurance.accidentDate,
        accidentNumber: data.accidentInsurance.accidentNumber,
        type: 'A'
      });
    if (data.aiInsurance !== null)
      state.preAdmissionData.patient.insurances.push({
        name: data.aiInsurance.name,
        type: 'I'
      });
    if (data.militaryInsurance !== null)
      state.preAdmissionData.patient.insurances.push({
        name: data.militaryInsurance.name,
        type: 'M'
      });
  },
  storePreAdmissionSuccess(state, data) {
    state.preAdmissionSuccess = data;
  }
};

export const actions = {
  sendPreAdmissionData({ commit, dispatch, state }) {
    return new Promise((resolve, reject) => {
      sendPreAdmissionData(state.preAdmissionData)
        .then((response) => {
          commit('storePreAdmissionData', response.data);
          dispatch('sendFormDataToMobile', response.data);
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  storeOptionsPreAdmission({ commit }) {
    return new Promise((resolve, reject) => {
      optionPreAdmission()
        .then((response) => {
          commit('storePreAdmissionOptions', response.data);
          let civilStates = [];
          response.data.actions.POST.patient.children.civil_state.choices.forEach(
            (civilState) => {
              civilStates.push({
                code: civilState.value,
                name: civilState.display_name
              });
            }
          );
          commit('storeCivilStates', civilStates);

          let sites = [];
          response.data.actions.POST.appointment.children.site.choices.forEach(
            (site) => {
              sites.push({
                code: site.value,
                name: site.display_name
              });
            }
          );
          commit('storeSites', sites);
          let administrativeContactsRelationships =[]
          response.data.actions.POST.administrative_contacts.child.children.relationship.choices.forEach(
            (relationship) => {
              administrativeContactsRelationships.push({
                code: relationship.value,
                name: relationship.display_name
              });
            }
          );
          commit('storeAdministrativeContactsRelationships', administrativeContactsRelationships);

          let emergencyContactsRelationships =[]
          response.data.actions.POST.emergency_contacts.child.children.relationship.choices.forEach(
            (relationship) => {
              emergencyContactsRelationships.push({
                code: relationship.value,
                name: relationship.display_name
              });
            }
          );
          commit('storeEmergencyContactsRelationships', emergencyContactsRelationships);
          let confessions =[]
          response.data.actions.POST.patient.children.confession.choices.forEach(
            (confession) => {
              confessions.push({
                code: confession.value,
                name: confession.display_name
              });
            }
          );
          commit('storeConfessions', confessions);

          let roomDivisions =[]
          response.data.actions.POST.patient.children.insurances.child.children.room_division.choices.forEach(
            (roomDivision) => {
              roomDivisions.push({
                code: roomDivision.value,
                name: roomDivision.display_name
              });
            }
          );
          commit('storeRoomDivisions', roomDivisions);

          // -------
          let languages =[]
          response.data.actions.POST.patient.children.contact_language.choices.forEach(
            (language) => {
              languages.push({
                code: language.value,
                name: language.display_name
              });
            }
          );
          commit('storeLanguages', languages);

          let genders =[]
          response.data.actions.POST.patient.children.sex.choices.forEach(
            (gender) => {
              genders.push({
                code: gender.value,
                name: gender.display_name
              });
            }
          );
          commit('storeGenders', genders);

          let rdvStepReasons =[]
          response.data.actions.POST.appointment.children.motive.choices.forEach(
            (reason) => {
              rdvStepReasons.push({
                code: reason.value,
                name: reason.display_name
              });
            }
          );
          commit('storeRdvStepReasons', rdvStepReasons);


          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  sendFormDataToMobile(_, data) {
    if (window.nativeApp) {
      // Android
      window.nativeApp.sendFormDataToMobile(JSON.stringify(data));
    } else if (
      window['webkit'] &&
      window['webkit'].messageHandlers &&
      window['webkit'].messageHandlers.nativeApp
    ) {
      // IOS
      window['webkit'].messageHandlers.nativeApp.postMessage({
        sendFormDataToMobile: data
      });
    }
  },
  storeFcmRegistrationToken({ commit }, token) {
    commit('storeFcmRegistrationToken', token);
  },
  storeUserInfo({ commit, state }, data) {
    if (Object.keys(data).length == 0) data = (state.userInfo === null ? {} : null)
    commit('storeUserInfo', data);
  },
  storeIdentifierStep({ commit }, data) {
    commit('storeIdentifierStep', data);
  },
  storeRdvStep({ commit }, data) {
    commit('storeRdvStep', data);
  },
  storePersonalDataStep({ commit }, data) {
    return new Promise((resolve) => {
      commit('storePersonalDataStep', data);
      resolve();
    });
  },
  storeEmployerStep({ commit }, data) {
    commit('storeEmployerStep', data);
  },
  storeContactsStep({ commit }, data) {
    commit('storeContactsStep', data);
  },
  storeAssurancesStep({ commit }, data) {
    commit('storeAssurancesStep', data);
  },
  storeDoctorStep({ commit }, data) {
    commit('storeDoctorStep', data);
  }
};

export const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
